export enum PICKUP_IDS {
  PICK_UP = 'PICK-UP',
  PICK_UP_MONTHLY_28 = 'PICK-UP-MONTHLY-28',
  PICK_UP_MONTHLY_30 = 'PICK-UP-MONTHLY-30',
  PICK_UP_QUARTERLY_84 = 'PICK-UP-QUARTERLY-84',
  PICK_UP_QUARTERLY_90 = 'PICK-UP-QUARTERLY-90',
}

export enum HYBRID_PICKUP_IDS {
  HYBRID_MONTHLY_28 = 'HYBRID-MONTHLY-28',
  HYBRID_MONTHLY_30 = 'HYBRID-MONTHLY-30',
  HYBRID_MONTHLY_84 = 'HYBRID-QUARTERLY-84',
  HYBRID_MONTHLY_90 = 'HYBRID-QUARTERLY-90',
}

export enum NORMAL_DELIVERY_IDS {
  ONE_TIME = 'ONE-TIME',
  MONTHLY_28 = 'MONTHLY-28',
  MONTHLY_30 = 'MONTHLY-30',
  QUARTERLY_84 = 'QUARTERLY-84',
  QUARTERLY_90 = 'QUARTERLY-90',
}

export enum SPECIAL_DELIVERY_IDS {
  SPECIAL_ONE_TIME = 'SPECIAL-ONE-TIME',
  SPECIAL_MONTHLY_28 = 'SPECIAL-MONTHLY-28',
}

export const PICKUP_IDS_ARRAY: PICKUP_IDS[] = Object.values(PICKUP_IDS);
export const HYBRID_PICKUP_IDS_ARRAY: HYBRID_PICKUP_IDS[] = Object.values(HYBRID_PICKUP_IDS);
export const NORMAL_DELIVERY_IDS_ARRAY: NORMAL_DELIVERY_IDS[] = Object.values(NORMAL_DELIVERY_IDS);
export const SPECIAL_DELIVERY_IDS_ARRAY: SPECIAL_DELIVERY_IDS[] = Object.values(SPECIAL_DELIVERY_IDS);
